// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Profile_wrapper__3Jbjv","content":"Profile_content__6R8o0","text":"Profile_text__3toXf","image":"Profile_image__2E77p"};